import { KeyboardEvent, MouseEvent } from 'react'
import { useSwiper } from 'swiper/react'
import { MdChevronRight } from 'react-icons/md'

export const SlideNextButton = () => {
  const swiper = useSwiper()

  const handleNext = (event: MouseEvent | KeyboardEvent) => {
    event.stopPropagation()
    if (!swiper.destroyed) {
      swiper?.slideNext?.()
    }
  }

  const handleKeyPressNext = (event: KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation()
      handleNext(event)
    }
  }
  return (
    <div
      data-testid="slide-next-button"
      onClick={handleNext}
      onKeyDown={handleKeyPressNext}
      role="button"
      tabIndex={0}
      className="h-full w-[36px] flex items-center justify-center absolute  top-0 right-0 z-[3] active:bg-transparent  select-none active:select-none"
    >
      <MdChevronRight className="text-white min-w-[24px] min-h-[24px]" />
    </div>
  )
}

export default SlideNextButton
